import { render } from "./AppDataTable.vue?vue&type=template&id=1c679f1e&scoped=true"
import script from "./AppDataTable.vue?vue&type=script&lang=js"
export * from "./AppDataTable.vue?vue&type=script&lang=js"

import "./AppDataTable.vue?vue&type=style&index=0&id=1c679f1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c679f1e"]])

export default __exports__